/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".bg[_ngcontent-%COMP%]{margin-top:10%;margin-bottom:5%}.icon-calendar[_ngcontent-%COMP%]{margin-top:-8px!important}p[_ngcontent-%COMP%]{font-size:22px;margin-top:0;margin-bottom:1rem}ul[_ngcontent-%COMP%]{list-style:none}ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{font-size:18px;line-height:2}"];
export { styles as styles };
